export const COMBAT_BACKGROUND_ART = {
  textureKey: 'bg_combat_ash_cathedral',
  path: '/assets/backgrounds/bg_combat_ash_cathedral.webp',
} as const;

export const FIRST_PERSON_ART = {
  textureKey: 'player_first_person',
  path: '/assets/overlays/player_first_person.webp',
} as const;

export const PLAYER_PORTRAIT_PATH = '/assets/characters/player_portrait.webp';

export const FONT_ART_PATHS = [
  '/assets/fonts/be-vietnam-pro/be-vietnam-pro-400-latin.woff2',
  '/assets/fonts/be-vietnam-pro/be-vietnam-pro-400-vietnamese.woff2',
  '/assets/fonts/be-vietnam-pro/be-vietnam-pro-500-latin.woff2',
  '/assets/fonts/be-vietnam-pro/be-vietnam-pro-500-vietnamese.woff2',
  '/assets/fonts/be-vietnam-pro/be-vietnam-pro-600-latin.woff2',
  '/assets/fonts/be-vietnam-pro/be-vietnam-pro-600-vietnamese.woff2',
  '/assets/fonts/be-vietnam-pro/be-vietnam-pro-700-latin.woff2',
  '/assets/fonts/be-vietnam-pro/be-vietnam-pro-700-vietnamese.woff2',
  '/assets/fonts/cinzel/cinzel-variable-latin.woff2',
  '/assets/fonts/cinzel/cinzel-variable-latin-ext.woff2',
] as const;

export const UI_CHROME_ART = {
  panelFrame: '/assets/ui/frames/panel-frame.svg',
  cardFrame: '/assets/ui/frames/card-frame.svg',
  corner: '/assets/ui/ornaments/corner.svg',
  divider: '/assets/ui/ornaments/divider.svg',
  grain: '/assets/ui/textures/grain.webp',
  levelCrest: '/assets/ui/crests/level-crest.svg',
  playerCombatCrest: '/assets/ui/crests/player-combat-crest.svg',
  mapNodeFrame: '/assets/ui/map/map-node-frame.svg',
  currentMarker: '/assets/ui/map/current-marker.svg',
  compass: '/assets/ui/map/compass.svg',
} as const;

export interface EnemyArtDefinition {
  textureKey: string;
  path: string;
  /** Image anchor aligned to the combat ground point. */
  anchorY: number;
  maxWidthRatio: number;
  maxHeightRatio: number;
  offsetX?: number;
  offsetY?: number;
}

export const ENEMY_ART: Record<string, EnemyArtDefinition> = {
  ambusher: {
    textureKey: 'enemy_ambusher',
    path: '/assets/enemies/ambusher.webp',
    anchorY: 0.95,
    maxWidthRatio: 0.34,
    maxHeightRatio: 0.68,
  },
  black_knight: {
    textureKey: 'enemy_black_knight',
    path: '/assets/enemies/black_knight.webp',
    anchorY: 0.96,
    maxWidthRatio: 0.43,
    maxHeightRatio: 0.76,
  },
  bone_guard: {
    textureKey: 'enemy_bone_guard',
    path: '/assets/enemies/bone_guard.webp',
    anchorY: 0.96,
    maxWidthRatio: 0.36,
    maxHeightRatio: 0.7,
  },
  demon_commander: {
    textureKey: 'enemy_demon_commander',
    path: '/assets/enemies/demon_commander.webp',
    anchorY: 0.98,
    maxWidthRatio: 0.42,
    maxHeightRatio: 0.75,
  },
  giant_spider: {
    textureKey: 'enemy_giant_spider',
    path: '/assets/enemies/giant_spider.webp',
    anchorY: 0.98,
    maxWidthRatio: 0.48,
    maxHeightRatio: 0.54,
    offsetY: 20,
  },
};

export function enemyArtFor(enemyId: string): EnemyArtDefinition | undefined {
  return ENEMY_ART[enemyId];
}

const SKILL_ART: Record<string, string> = {
  slash: '/assets/skills/slash.webp',
  gale: '/assets/skills/gale.webp',
  ember: '/assets/skills/ember.webp',
  tide: '/assets/skills/tide.webp',
  spark: '/assets/skills/spark.webp',
  radiant_bolt: '/assets/skills/radiant_bolt.webp',
};

export function skillArtPath(skillId: string): string | undefined {
  return SKILL_ART[skillId];
}
